import React, { useState } from "react";
import { FaEnvelope, FaEye, FaEyeSlash } from "react-icons/fa";
import { IconButton } from "@mui/material";

const Input = ({
  label,
  onChange,
  value,
  type,
  optional,
  placeholder,
  obscured= false,
  suffixIcon,
  onBlur,
  name,
  icon, // New prop for the icon
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="font-inter">
      <label className="text-[#000000] font-inter font-normal  text-[16px] my-2 flex">
        {label}
        {optional && (
          <span className="text-xs text-gray-400 pl-1">Optional</span>
        )}
      </label>
      <div className="relative">
        {icon && (
          <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
            {icon} {/* Dynamically rendering the icon */}
          </span>
        )}
        <input
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          name={name}
          type={obscured ? (!showPassword ? "password" :"text") :type}
          className="appearance-none border border-gray-300 rounded-lg w-full py-3 px-10 text-[#000000] font-normal font-inter  leading-tight focus:outline-none"
          style={{ paddingLeft: "40px" }} // Extra padding to make space for the icon
          {...props}
        />
        <div className="right-0 top-0 absolute flex items-center justify-center w-[50px] h-full">
          {obscured ? (
            <span
              className="px-2 text-gray-400"
              onClick={togglePasswordVisibility}
            >
              <IconButton size="small">
                {showPassword ? <FaEye /> : <FaEyeSlash />}
              </IconButton>
            </span>
          ) : suffixIcon ? (
            <span className="px-2 text-gray-400">{suffixIcon}</span>
          ) : type === "email" ? (
            <span className="px-2 text-gray-400">
              <FaEnvelope />
            </span>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};

export default Input;
